import {
  addMonths,
  differenceInCalendarMonths,
  differenceInDays,
  getDaysInMonth,
} from "date-fns";

export function differenceInPartialMonths(from: Date, to: Date): number {
  const wholeMonths = differenceInCalendarMonths(to, from);
  const anchor = addMonths(from, wholeMonths);

  const remainingDays = differenceInDays(to, anchor);
  const daysInMonth = getDaysInMonth(anchor);

  return wholeMonths + (remainingDays / daysInMonth);
}
